export const passosLinhaTempo = [
  {
    numero: 1,
    titulo: "Identifique sua Linha do Tempo",
    descricao: "Descubra como seu cérebro organiza o tempo espacialmente",
    cor: "from-violet-500 to-purple-600",
    icone: "ri-time-line"
  },
  {
    numero: 2,
    titulo: "Flutue Acima da Linha",
    descricao: "Posicione-se em uma perspectiva dissociada e segura",
    cor: "from-purple-500 to-fuchsia-600",
    icone: "ri-flight-takeoff-line"
  },
  {
    numero: 3,
    titulo: "Vá ao Evento Raiz",
    descricao: "Localize a primeira vez que sentiu essa emoção",
    cor: "from-fuchsia-500 to-pink-600",
    icone: "ri-map-pin-time-line"
  },
  {
    numero: 4,
    titulo: "Libere a Emoção Negativa",
    descricao: "Permita que a emoção se dissolva mantendo o aprendizado",
    cor: "from-pink-500 to-rose-600",
    icone: "ri-heart-pulse-line"
  },
  {
    numero: 5,
    titulo: "Preserve o Aprendizado",
    descricao: "Identifique a lição valiosa que você pode manter",
    cor: "from-rose-500 to-red-600",
    icone: "ri-lightbulb-line"
  },
  {
    numero: 6,
    titulo: "Ressignifique o Evento",
    descricao: "Dê um novo significado empoderador à experiência",
    cor: "from-red-500 to-orange-600",
    icone: "ri-refresh-line"
  },
  {
    numero: 7,
    titulo: "Crie seu Futuro Motivador",
    descricao: "Visualize como será sua vida sem essa limitação",
    cor: "from-orange-500 to-amber-600",
    icone: "ri-rocket-line"
  },
  {
    numero: 8,
    titulo: "Integre as Mudanças",
    descricao: "Retorne ao presente com a nova programação instalada",
    cor: "from-amber-500 to-yellow-600",
    icone: "ri-checkbox-circle-line"
  }
];

export const exemplosEventos = [
  {
    emocao: "Medo de Rejeição",
    evento: "Aos 8 anos, fui excluído de uma brincadeira na escola e todos riram de mim",
    decisaoLimitante: "Não sou aceito pelos outros, preciso me esconder para não ser rejeitado",
    aprendizado: "Aprendi a ser mais observador e empático com quem se sente excluído",
    novoSignificado: "Aquela experiência me ensinou compaixão. Hoje escolho pessoas que me valorizam.",
    futuroDesejado: "Me vejo confiante em grupos sociais, expressando minhas ideias livremente e sendo bem recebido"
  },
  {
    emocao: "Raiva de Injustiça",
    evento: "Aos 12 anos, fui punido por algo que não fiz e ninguém acreditou em mim",
    decisaoLimitante: "O mundo é injusto e eu não tenho voz, não adianta me defender",
    aprendizado: "Aprendi a importância de buscar a verdade e defender os outros",
    novoSignificado: "Aquela injustiça me tornou alguém que luta por transparência e justiça.",
    futuroDesejado: "Me vejo defendendo minhas verdades com calma, sendo ouvido e respeitado"
  },
  {
    emocao: "Tristeza de Perda",
    evento: "Aos 15 anos, perdi meu avô que era meu maior apoio emocional",
    decisaoLimitante: "Pessoas que amo sempre vão me deixar, não posso me apegar muito",
    aprendizado: "Aprendi o valor de cada momento e a importância de expressar amor",
    novoSignificado: "Meu avô me ensinou a amar profundamente. Sua memória me fortalece.",
    futuroDesejado: "Me vejo criando vínculos profundos, aproveitando cada momento com quem amo"
  },
  {
    emocao: "Culpa por Erro",
    evento: "Aos 20 anos, tomei uma decisão que prejudicou alguém que eu amava",
    decisaoLimitante: "Sou uma pessoa ruim, não mereço ser feliz depois do que fiz",
    aprendizado: "Aprendi a importância de assumir responsabilidade e reparar danos",
    novoSignificado: "Aquele erro me ensinou empatia e me tornou mais consciente das minhas escolhas.",
    futuroDesejado: "Me vejo tomando decisões sábias, perdoando a mim mesmo e ajudando outros"
  },
  {
    emocao: "Vergonha de Fracasso",
    evento: "Aos 18 anos, falhei publicamente em uma apresentação importante",
    decisaoLimitante: "Não sou capaz, todos vão me julgar se eu tentar de novo",
    aprendizado: "Aprendi que falhar faz parte do processo de crescimento",
    novoSignificado: "Aquele fracasso me ensinou resiliência. Cada tentativa me torna mais forte.",
    futuroDesejado: "Me vejo apresentando com confiança, sabendo que erros são oportunidades"
  }
];

export const dicasSeguranca = [
  "Mantenha-se sempre dissociado (vendo de fora) ao trabalhar com eventos traumáticos",
  "Se a emoção ficar muito intensa, volte ao presente imediatamente",
  "Trabalhe primeiro com eventos menos intensos para ganhar prática",
  "Preserve sempre o aprendizado antes de liberar a emoção",
  "Use a técnica em ambiente seguro e tranquilo",
  "Se necessário, busque apoio de um terapeuta qualificado",
  "Não force a liberação - permita que aconteça naturalmente",
  "Celebre cada pequeno progresso na redução da intensidade emocional",
  "Pratique auto-compaixão durante todo o processo",
  "Lembre-se: você está no controle e pode pausar a qualquer momento"
];

export const tiposOrganizacaoTempo = {
  inTime: {
    titulo: "In Time (Dentro do Tempo)",
    descricao: "Você está imerso no momento presente, o passado fica atrás e o futuro à frente",
    caracteristicas: ["Vive intensamente o agora", "Pode perder noção do tempo", "Mais emocional e espontâneo"]
  },
  throughTime: {
    titulo: "Through Time (Através do Tempo)",
    descricao: "Você vê o tempo como uma linha à sua frente, consegue ver passado e futuro simultaneamente",
    caracteristicas: ["Pontual e organizado", "Planeja com antecedência", "Mais analítico e estruturado"]
  }
};
